var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ComponentContext } from '@employee-experience/common/lib/ComponentContext';
import { TelemetryEvents } from '@employee-experience/common/lib/TelemetryEvents';
import { shouldUseAnchorTag } from '@employee-experience/common/lib/Link';
const rootHref = '/';
function isLinkSelected(href) {
    const { pathname } = window.location;
    if (href === rootHref)
        return pathname === href;
    return pathname.startsWith(href);
}
export function useCoherenceNavGroups(groups) {
    const { telemetryClient } = useContext(ComponentContext);
    const history = useHistory();
    const [navGroups, setNavGroups] = useState([]);
    const createLinkGroup = (groups) => {
        return groups.map((_a) => {
            var { links: groupLinks } = _a, otherGroupProps = __rest(_a, ["links"]);
            return Object.assign(Object.assign({}, otherGroupProps), { links: createChildLinks(groupLinks) || [] });
        });
    };
    const createLink = (name, href) => {
        return {
            name,
            onClick: () => {
                telemetryClient.trackTrace({
                    message: TelemetryEvents.NavLinkClicked,
                    properties: {
                        linkName: name,
                        href,
                    },
                });
                if (shouldUseAnchorTag(href, false)) {
                    window.open(href);
                }
                else {
                    history.push(href);
                    setNavGroups(createLinkGroup(groups));
                }
            },
            isSelected: isLinkSelected(href),
        };
    };
    const createChildLinks = (childLinks) => {
        if (!childLinks)
            return;
        return childLinks.map((_a) => {
            var { links, href, name } = _a, otherLinkProps = __rest(_a, ["links", "href", "name"]);
            return Object.assign(Object.assign(Object.assign({}, otherLinkProps), createLink(name, href)), { links: createChildLinks(links) });
        });
    };
    useEffect(() => {
        setNavGroups(createLinkGroup(groups));
    }, [groups]);
    return navGroups;
}
//# sourceMappingURL=useCoherenceNavGroups.js.map